import { z } from "zod";
import { type UserGamificationStats } from "../../firestore";
import { type FunctionObjectReturn } from "../utils";

export const BootstrapGamificationFromActivityLogBodySchema = z.preprocess(
  (value) => value ?? {},
  z.object({}).strict(),
);

export type BootstrapGamificationFromActivityLogBody = z.infer<typeof BootstrapGamificationFromActivityLogBodySchema>;

export type BootstrapGamificationFromActivityLogHeuristic =
  | "canonical_lesson_minutes"
  | "stored_pointsEarned"
  | "mixed";

export type BootstrapGamificationFromActivityLogPayload = {
  /** True when a new stats document was created from ActivityLog replay. */
  created: boolean;
  /** True when an existing thin stats document was replaced by ActivityLog replay. */
  replaced: boolean;
  heuristic: BootstrapGamificationFromActivityLogHeuristic;
  totalLogsScanned: number;
  logsSkipped: number;
  sessionsCounted: number;
  estimatedPoints: number;
  stats: UserGamificationStats;
};

export type BootstrapGamificationFromActivityLogResponse =
  FunctionObjectReturn<BootstrapGamificationFromActivityLogPayload>;
